import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoteInlineComponent } from './note-inline.component';

import { DxDropDownBoxModule } from 'devextreme-angular';
import { NoteViewerModule } from '../note-viewer/note-viewer.module';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  declarations: [
    NoteInlineComponent,
  ],
  imports: [
    CommonModule,
    DxDropDownBoxModule,
    NoteViewerModule,
    MatDividerModule, MatButtonModule
  ],
  exports: [
    NoteInlineComponent
  ]
})
export class NoteInlineModule { }
